import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { ExchangeRatesProvider } from './contexts/ExchangeRatesContext';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  const content = useRoutes(router);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ExchangeRatesProvider>
          <CssBaseline />
          <AuthProvider>{content}</AuthProvider>
        </ExchangeRatesProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
